import { css } from 'styled-components';

import { MobileCartUpsellLocation } from '../types';

import { IContentProps, MobileAreaOptions, WebAreaOptions } from './types';

export const mobileGridCSS = ({
  upsellEnabled,
  mobileCartUpsellLocation = MobileCartUpsellLocation.AboveYourCart,
}: IContentProps) => {
  // use this array as base for grid template area order
  let areaOrder = [MobileAreaOptions.DETAILS, MobileAreaOptions.CART, MobileAreaOptions.PAYMENT];

  /**
   * handle upsell enabled, 2 possible options:
   *  1. above cart
   *  2. above payment
   */
  if (upsellEnabled && mobileCartUpsellLocation === MobileCartUpsellLocation.AboveYourCart) {
    const cartPosition = areaOrder.indexOf(MobileAreaOptions.CART);
    areaOrder = [
      ...areaOrder.slice(0, cartPosition),
      MobileAreaOptions.UPSELL,
      ...areaOrder.slice(cartPosition),
    ];
  } else if (
    upsellEnabled &&
    mobileCartUpsellLocation === MobileCartUpsellLocation.AbovePaymentDetails
  ) {
    const paymentPosition = areaOrder.indexOf(MobileAreaOptions.PAYMENT);
    areaOrder = [
      ...areaOrder.slice(0, paymentPosition),
      MobileAreaOptions.UPSELL,
      ...areaOrder.slice(paymentPosition),
    ];
  }

  // create template areas in proper order
  const gridTemplateAreas = areaOrder.reduce((acc, cur) => {
    return `${acc}
    '${cur}'`;
  }, '');

  return css`
    grid-template-areas: ${gridTemplateAreas};
  `;
};

export const webGridCss = ({ upsellEnabled }: IContentProps) => {
  let areaOrder = [WebAreaOptions.DETAILS, WebAreaOptions.PAYMENT];

  // handle upsell enabled
  if (upsellEnabled) {
    const paymentPosition = areaOrder.indexOf(WebAreaOptions.PAYMENT);
    areaOrder = [
      ...areaOrder.slice(0, paymentPosition),
      WebAreaOptions.UPSELL,
      ...areaOrder.slice(paymentPosition),
    ];
  }

  // create template areas in proper order
  const gridTemplateAreas = areaOrder.reduce((acc, cur) => {
    return `${acc}
    '${cur}'`;
  }, '');

  return css`
    grid-template-areas: ${gridTemplateAreas};
  `;
};
